import React from 'react';
import { Routes, Route} from 'react-router-dom';
import Navbar from './components/common/navbar/Navbar';
import Home from './components/home/Home';
import AboutPage from './components/about/AboutPage';
import ServiceDetail from './components/services/ServiceDetail';
import Contact from './components/contactus/Contact';
import TotalGallery from './components/gallery/TotalGallery';
import Footer from './components/common/footer/Footer';

function App() {


  return (
  <>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/service/:id" element={<ServiceDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gallery" element={<TotalGallery />} />
          </Routes>
          <Footer />
        </>
    
    
  );
}

export default App;
